import { render, staticRenderFns } from "./RecurringDocumentTable.vue?vue&type=template&id=66b4f13e&"
import script from "./RecurringDocumentTable.vue?vue&type=script&lang=js&"
export * from "./RecurringDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports